import { PROJECT_NAME } from "../config";

const translationModules = require.context("../translations", true, /\.(json)$/);

// Priority order: project-specific → root translations
// Add new fallback folders here — AppRouter never needs to change
const FALLBACK_FOLDERS = [
  ...(PROJECT_NAME ? [PROJECT_NAME] : []),
  null, // null = root of translations
];

export const getTranslations = (lang) => {
  for (const folder of FALLBACK_FOLDERS) {
    const path = folder ? `./${folder}/${lang}.json` : `./${lang}.json`;
    try {
      return translationModules(path);
    } catch {
      // not found in this path, try next
    }
  }

  console.warn(`Translations not found for: ${lang} (version: ${PROJECT_NAME})`);
  return {};
};
